/**
 * The billable duration of a file whose metadata may never have loaded.
 *
 * `HTMLVideoElement.duration` is `NaN` before metadata arrives and `Infinity` for some
 * streamed containers, either of which would render "NaN min" and poison every downstream
 * total. Both the modal's Create gate and ReviewStep's displayed cost funnel durations
 * through this guard so the number the user is quoted and the number the gate checks can
 * never disagree.
 */
export const billableSeconds = (seconds?: number): number =>
  typeof seconds === "number" && Number.isFinite(seconds) && seconds > 0 ? seconds : 0;

/**
 * Minutes a single media file is billed for.
 *
 * The backend charges `ceil(seconds / 60)` PER FILE PER LANGUAGE, so the rounding has to
 * happen before anything is summed or multiplied. Summing raw seconds first and rounding
 * the total undercounts (two 60.1s files bill 2 + 2 = 4 minutes, not `ceil(120.2 / 60)` = 3)
 * and would quote the user a cheaper number than they are actually charged.
 */
export {billedMinutesForFile} from "./creditsCost.ts";
